module.exports = __webpack_public_path__ + "static/media/hk.50fa2f99.svg";